<script setup lang="ts">
  defineOptions({
    name: 'ConfiguratorHeader'
  })

  const logoUrl = `${import.meta.env.BASE_URL}logo_suzuki.svg`
</script>

<template>
  <header class="layout-header">
    <img :src="logoUrl" alt="Suzuki" class="header-logo" />
    <h1 class="header-title">PRÉCOMMANDEZ VOTRE e VITARA</h1>
  </header>
</template>

<style scoped>
  
  .layout-header {
    grid-area: header;
    background: var(--color-text-primary);
    color: var(--color-text-inverse);
    padding: var(--spacing-xs) var(--spacing-lg);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-block-end: 0.5rem;
  }

  .header-logo {
    height: 24px;
    width: auto;
    position: absolute;
    left: var(--spacing-lg);
  }

  .header-title {
    margin: 0;
    font-size: var(--font-size-xl);
    font-weight: 700;
    letter-spacing: 1px;
    color: var(--color-text-inverse);
  }
  /* Responsive */
  @media (max-width: 768px) {
    .layout-header {
      flex-direction: column;
      gap: var(--spacing-xs);
    }

    .header-logo {
      position: static;
      height: 20px;
    }

    .header-title {
      font-size: var(--font-size-lg);
    }
  }
</style>